var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{attrs:{"title":"Сменить тариф"},on:{"close":function($event){return _vm.close()}}},[_c('h2',[_vm._v("Нет списка тарифов")])])}
var staticRenderFns = []

export { render, staticRenderFns }